import { colors } from '@imprint-payments/imprint-ui';

// TODO
export default function ChannelSelection() {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '480px',
        height: '530px',
        padding: '16px',
        backgroundColor: colors.surface.surfaceLow,
        borderRadius: '12px',
      }}
    >
      Channel Selection Component
    </div>
  );
}
